<template>
  <div class="">
    <div class="mt-2" style="border-bottom: 1px solid #f0f0f1;" :style="{ 'margin-right': `${margin}px` }">
      <input
          v-if="!isCategoryHaveChild"
          type="checkbox"
          ref="categoryItem"
          :id="`category-item-${category.id}`"
          :value="category[categoryColumn]" @input="emitData"
      />

      <label v-if="!isCategoryHaveChild" :for="`category-item-${category.id}`" class="mr-1">
        {{ category.name }}
      </label>

      <label v-else class="mr-1 cursor-pointer" data-toggle="collapse"
             :data-target="'#collapse-'+category.id">
        {{ category.name }}
      </label>

      <i class="bi bi-chevron-left mr-1 text-dark" data-toggle="collapse" :data-target="'#collapse-'+category.id"
         v-if="category.children.length"/>
    </div>

    <div class="collapse" :id="'collapse-'+category.id">
      <category :model-value="modelValue" :margin="margin+15" :category-column="categoryColumn"
                v-for="children in categoryChildren"
                :category="children"/>
    </div>

  </div>
</template>

<script>
export default {
  name: "Category",
  props: {
    category: {},
    modelValue: {},
    categoryColumn: {
      default: 'id',
      validator(value) {
        // The value must match one of these strings
        return ['id', 'slug'].includes(value)
      }
    },
    margin: {
      default: 0
    },
  },
  data() {
    return {
      categoryChildren: []
    }
  },
  computed: {
    isCategoryHaveChild() {
      return this.category.children.length > 0
    }
  },
  methods: {
    emitData(event) {
      const inputElement = event.target;
      if (inputElement.checked == true && this.category[this.categoryColumn] == inputElement.value) {

        this.modelValue.push(this.category[this.categoryColumn])

      } else if (inputElement.checked == false && this.category[this.categoryColumn] == inputElement.value) {
        // remove item from modelValue
        var i = 0;
        while (i < this.modelValue.length) {
          if (this.modelValue[i] == this.category[this.categoryColumn]) {
            this.modelValue.splice(i, 1);
          } else {
            ++i;
          }
        }
      }
      this.$emit('update:modelValue', this.modelValue)
    },
    checkInputChecked() {
      // set check value of inputs
      if (!this.isCategoryHaveChild) {
        if (this.modelValue.find(element => element == this.category[this.categoryColumn]) !== undefined) {
          this.$refs['categoryItem'].checked = true
        } else {
          this.$refs['categoryItem'].checked = false
        }
      }
    },
    setCategoriesChildren() {
      // set up categories children
      if (this.isCategoryHaveChild) {

        this.category.children.forEach(item => {
          this.categoryChildren.push(item)
        })

        this.categoryChildren.push({
          id: this.category.id,
          name: `همه ی ${this.category.name}`,
          slug: this.category.slug,
          children: []
        })

        this.categoryChildren.reverse();


      }
    }
  },
  mounted() {
    this.checkInputChecked()
    this.setCategoriesChildren()
  }
}
</script>

<style scoped>
.cursor-pointer {
  cursor: pointer;
}
</style>